export const AmenityColumns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Amenity Name",
    accessor: "name",
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
  },
];
